<template>
  <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="formattedDate"
        label="Select Date"
        prepend-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        v-on="on"
        style="max-width: 50%; padding: 10px"
      ></v-text-field>
    </template>
    <v-date-picker v-model="date" @input="menu = false"></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  props: {
    value: String,
  },
  data() {
    return {
      menu: false,
      date: this.value,
    };
  },
  computed: {
    formattedDate() {
      if (!this.date) {
        return null;
      }
      const [year, month, day] = this.date.split("-");
      return `${day}/${month}/${year}`;
    },
  },
  watch: {
    date(newVal) {
      this.$emit("input", newVal);
    },
    value(newVal) {
      this.date = newVal;
    },
  },
};
</script>
